import { render, staticRenderFns } from "./alignBottom_off.vue?vue&type=template&id=08c287b2&"
import script from "./alignBottom_off.vue?vue&type=script&lang=ts&"
export * from "./alignBottom_off.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports